import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  StetheAttendanceRetrievActions,
  StetheAttendanceApproveActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/LeavePermission/LeavePermission.scss";
import Shift from "../Shift/Shift";

const AttendanceRequestApprove = (props) => {
  const {
    currentPage,
    setShow,
    show,
    EditId,
    selectVal,
    data,
    from_dates,
    to_dates,
    white_collar,
    search,
    makereadOnly,
  } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const [descpErr, setdeserr] = useState("");
  const initialState = {
    status: "",

    purpose: "",
    Attendance_type: "",
    user_id: "",
    user_name: "",
    description: "",
    Shift: "",
    StartTime: "",
    EndTime: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    const payload = {
      EditID: EditId,
    };

    dispatch(StetheAttendanceRetrievActions(payload));
  }, []);
  console.log(
    state.AttendanceRetriveCall.AttendanceListRetrievDatas,
    "AttendanceListRetrievDatas",
  );
  useEffect(() => {
    var attendance_typeRetrie = "";
    // console.log(state, "692369r7dujsef");
    if (
      state.AttendanceRetriveCall.AttendanceListRetrievDatas != undefined &&
      state.AttendanceRetriveCall.AttendanceListRetrievDatas.Attendance_type !=
        undefined
      //   &&
      //   state.AttendanceRetriveCall.AttendanceListRetrievDatas.grievance_type
      //   .grievance_type != null  &&
      // state.AttendanceRetriveCall.AttendanceListRetrievDatas.grievance_type
      //   .grievance_type.grievance_type != null &&
      // state.AttendanceRetriveCall.AttendanceListRetrievDatas.grievance_type
      //   .grievance_type.grievance_type != undefined
    ) {
      attendance_typeRetrie =
        state.AttendanceRetriveCall.AttendanceListRetrievDatas.Attendance_type
          .leave_type;
    }

    if (
      state.AttendanceRetriveCall.AttendanceListRetrievDatas.id != undefined
    ) {
      setDatas({
        ...Data,
        Attendance_type: attendance_typeRetrie,

        user_name:
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.user_id
            .first_name,

        description:
          state.AttendanceRetriveCall.AttendanceListRetrievDatas
            .reason_for_decline,
        status: state.AttendanceRetriveCall.AttendanceListRetrievDatas.status,
        Shift:
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.shift_id !=
            undefined &&
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.shift_id !=
            null
            ? state.AttendanceRetriveCall.AttendanceListRetrievDatas.shift_id
                .shift_name
            : "--",
        StartTime:
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.from_time !=
            undefined &&
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.from_time !=
            null &&
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.from_time !=
            undefined
            ? state.AttendanceRetriveCall.AttendanceListRetrievDatas.from_time?.split(
                "T",
              )[0]
            : "----",

        EndTime:
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.to_date !=
            undefined &&
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.to_date !=
            null &&
          state.AttendanceRetriveCall.AttendanceListRetrievDatas.to_date !=
            undefined
            ? state.AttendanceRetriveCall.AttendanceListRetrievDatas.to_date
            : "----",
      });
    }
  }, [state.AttendanceRetriveCall.AttendanceListRetrievDatas]);

  const HandleChanges = (e) => {
    console.log(e, "324e");
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };

  console.log(Data, "Data", makereadOnly);
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    const payload = {
      status: Data.status.toLowerCase(),
      description: Data.description,
      EditId: EditId,
      currentPage: currentPage,
      selectVal: selectVal,
      data: data,
      // month :month, year :year
      from_date: from_dates,
      to_date: to_dates,
      white_collar: white_collar,
      search: search,
    };
    dispatch(StetheAttendanceApproveActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Attendance Request </span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3">
                          <div className="row">
                            {/* <div
                              className="col-12"
                              style={{ marginTop: "15px" }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label-Header"
                              >
                                From Date - To Date
                              </label>
                            </div> */}
                            <div className="row" style={{ marginLeft: "5px" }}>
                              <div className="col mt-3">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  start Date
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.StartTime}
                                  readOnly
                                />
                              </div>
                              {Data.EndTime != undefined &&
                              Data.EndTime != "" ? (
                                <div className="col mt-3">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    End Date
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="name"
                                    value={Data.EndTime}
                                    readOnly
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        {/* <div className="col mt-3">
                          <label for="validationCustom01" class="form-label">
                            Attendance type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.Attendance_type}
                            readOnly
                          />
                        </div> */}

                        {/* <div className="row"> */}
                        {/* <div className="col mt-3">
                          <label for="validationCustom01" class="form-label">
                            Shift type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.Shift}
                            readOnly
                          />
                        </div> */}
                        {/* </div> */}

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            // onChange={HandleChanges}

                            // readOnly={makereadOnly !=1  ? true : false}
                            disabled
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                // readOnly={makereadOnly == 0 ? true : false}
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {Data.status.toLowerCase() == "decline" ? (
                        <>
                          <div
                            className="col-sm-3 mt-3"
                            style={{ width: "700px" }}
                          >
                            <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                              readOnly={makereadOnly != 1 ? true : false}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        </>
                      ) : null}
                    </div>
                    {makereadOnly == 1 ? (
                      <div className="UserButtons">
                        <button
                          class="btn  SaveBtn"
                          type="submit"
                          onClick={(e) => {
                            HandleClick(e);
                          }}
                        >
                          Submit
                        </button>
                        <button
                          class="btn CancelBtn"
                          onClick={(e) => handleClose(e)}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceRequestApprove;
